import { v4 as uuidv4 } from 'uuid';

import { getCookie, setCookie } from './cookies';

export const COAST_VISITOR_ID_COOKIE = 'coast_visitor_id';

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

const visitorCookieDomain = (): string | undefined =>
  window.location.hostname.endsWith('coastpay.com') ? 'coastpay.com' : undefined;

export const ensureCoastVisitorId = (): string => {
  const existingVisitorId = getCookie(COAST_VISITOR_ID_COOKIE);
  const visitorId = existingVisitorId === undefined || existingVisitorId === '' ? uuidv4() : existingVisitorId;
  setCookie(COAST_VISITOR_ID_COOKIE, visitorId, {
    maxAgeSeconds: ONE_YEAR_IN_SECONDS,
    path: '/',
    domain: visitorCookieDomain(),
    secure: window.location.protocol === 'https:',
    sameSite: 'lax',
  });
  return visitorId;
};
